(function () {'use strict';}());

angular.module('elidb')
  .controller('FilterController', function ($scope,$timeout,$filter,$window,ELIService) { 
  	var trace = angular.trace;
  	$scope.ageGroups = [];
  	$scope.diagnosis = [];
    $scope.filterClasses = {};
    $scope.tempAgeGroup = {};
    $scope.tempDiagnosis = {};
    $scope.tempDisability = {};
    $scope.tempFilters = {};

    $scope.savedAgeGroup = {};
    $scope.savedDiagnosis = {};
    $scope.savedDisability = {};
    $scope.savedFilters = {};

    $scope.refineMeta = {};
    $scope.searchid = null;

    $scope.submissionClasses = {};
    $scope.submissionData = {email:null,name:null,details:null};

    $scope.profileComplete = false;
    $scope.resortSecondaryFilters = false;
    

    $scope.$watch("autoSearch",function(value){
      if(value !== true) return;

      $scope.tempAgeGroup = {10:true};
      $scope.tempDiagnosis = {72:true};
      $scope.tempDisability = {yes:"y"};
      $scope.tempFilters = {58:true};
      $scope.refineMeta = {zip: "02138",radius:"25"};
      $scope.filterClasses.age = false;
      $scope.filterClasses.diagnosis = false;
      $scope.filterClasses.disability = false;
      $scope.filterClasses.filters = false;
      $scope.filterClasses.searchComplete = true;
      $scope.applyRefinementFilters(["10","72","58"]);
    });

  	if(!$scope.ready) $scope.$watch("ready",onReady);
  	else onReady(true);

    $scope.resetSearch = function($event) {

      $event.preventDefault();
      $event.stopImmediatePropagation();

      $scope.tempAgeGroup = {};
      $scope.tempDiagnosis = {};
      $scope.tempDisability = {};
      $scope.tempFilters = {};

      $scope.savedAgeGroup = {};
      $scope.savedDiagnosis = {};
      $scope.savedDisability = {};
      $scope.savedFilters = {};

      updateSelectedTags(true);

    };

    $scope.addResource = function() {
      $scope.setRenderResourceModal(true);
      $timeout(function(){
        $scope.submissionClasses.rendered = true;
      },0);
    };

    $scope.submitResource = function() {
      $scope.submissionClasses.processing = true;
      ELIService.submitResource($scope.submissionData).then($scope.cancelResource);
    };

    $scope.cancelResource = function(event){

      $scope.submissionData = {};
      $scope.submissionClasses.rendered = false;

      if(event && event.preventDefault){
        event.preventDefault();
        $timeout(function(){
          $scope.submissionClasses.processing = false;
          $scope.setRenderResourceModal(false);
        },250);
      }
      else {
        $timeout(function(){
          $scope.submissionClasses.processing = false;
          $scope.setRenderResourceModal(false);
          $window.alert("Your resource was successfully submitted to the Exceptional Lives team for review. Thank you!");
        },250);
      }

       
    };

    $scope.categoryEnabled = function(category) {
      if(!$scope.searchid) return $scope.filterClasses[category] ? true : false;
      if(category === "filters") return $scope.nowEditing ? false : true;
      return $scope.nowEditing === category;
    };

    $scope.mobileEdit = function(){
      var state = !!$scope.filterClasses.mobileEdit;
      $scope.filterClasses.mobileEdit = !state;
      $scope.setMobileEditing($scope.filterClasses.mobileEdit);
      if(!$scope.filterClasses.mobileEdit) updateSelectedTags(true);
    };

    $scope.onZipChange = function(){
      var val = $scope.refineMeta.zip;
      if(val && val.length === 5) $scope.zipChanged(val);
    };

    $scope.onRadiusChange = function(){
      var val = $scope.refineMeta.radius;
      $scope.radiusChanged(val);
    };

    function filterSelectedTags(element){
      if(element.id === this.id) return false;
      if(element.type !== "Service" && element.type !== "Custom") return false;
      return element.selected ? true : false;
    }

    $scope.updateTagDependencies = function(item,model) {
     
      if(item) item.selected = model[item.id];

      for(var i = 0, count = $scope.tags.length; i < count; i++) {
        var tag = $scope.tags[i];
        var dependencies = ELIService.tagDependencies[tag.id];
        if(!dependencies) continue;

        var disabled = null;
        var selected = $scope.tags.filter(filterSelectedTags,tag);

        if(dependencies.length > 1) {
          if(selected.length) disabled = false;
          else disabled = true;
        }

        if(dependencies.length === 1) {
        for(var j = 0, numDeps = dependencies.length; j < numDeps; j++) {
          var dependency = dependencies[j];
          var target = ELIService.tagDictionary[dependency.dependsOn];
          if(!target) continue;

          //if(tag.id === 59) trace("testing target",target);

          var satisfied = target[dependency.dependsProperty] == dependency.dependsValue;
          if(!satisfied) continue;

         // if(tag.id === 59) trace("satisfied");

          if(disabled === null) disabled = dependency.setValue;
          else if(!disabled) disabled = dependency.setValue;
        } }


        tag.disabled = disabled;

        if(tag.disabled) {

         var smodels = [$scope.savedAgeGroup,$scope.savedDiagnosis,$scope.savedFilters,$scope.savedFilters];
         var tmodels = [$scope.tempAgeGroup,$scope.tempDiagnosis,$scope.tempFilters,$scope.tempFilters];
         var types = ["Age","Diagnosis","Custom","Service"];
         var smdl = smodels[types.indexOf(tag.type)];
         var tmdl = tmodels[types.indexOf(tag.type)];
         
         if(!smdl || !tmdl) {
          return trace("error finding model for tag",tag);
         }

         if(tag.disabled) {
          smdl[tag.id] = tmdl[tag.id] = false;
          tag.selected = false;
         }
        }
      }
    };

    $scope.filterSelect = function(tag,value){
      $scope.resortSecondaryFilters = $scope.filterClasses.searchComplete;
      $scope.commit('filters','Filters');
    };

    $scope.noAgeSelected = function(){
      for(var prop in $scope.tempAgeGroup){
        if($scope.tempAgeGroup[prop]) return false;
      }
      return true;
    };

    $scope.noDiagnosisSelected = function(){
      for(var prop in $scope.tempDiagnosis){
        if($scope.tempDiagnosis[prop]) return false;
      }
      return true;
    };

    $scope.noDisabilitySelected = function() {
      if($scope.tempDisability.yes) return false;
      return true;
    };

    $scope.noFiltersSelected = function(){

      var filterSelected, ageSelected, diagnosisSelected;
      var prop;

      for(prop in $scope.tempAgeGroup){
        if($scope.tempAgeGroup[prop]) ageSelected = true;
      }

      for(prop in $scope.tempDiagnosis){
        if($scope.tempDiagnosis[prop]) diagnosisSelected = true;
      }

      for(prop in $scope.tempFilters){
        if($scope.tempFilters[prop]) filterSelected = true;
      }
      
      if(filterSelected  && ageSelected && diagnosisSelected) return false;
      return true;
    };

    $scope.commit = function(type,model,setSortFlag){
      var source = $scope["temp"+model];
      var target = $scope["saved"+model] = {};
      $scope.filterClasses[type] = false;
      $scope.nowEditing = null;

      for(var prop in source){
        target[prop] = source[prop];
      }


      if($scope.filterClasses.searchComplete) 
      {
        //updateSelectedTags();
        ga('send', 'pageview','/search-results');
      }
      updateSelectedTags();

      if(setSortFlag) 
      {
        $scope.resortSecondaryFilters = true;
        $scope.triggerFilterSort();
      }

      sendSearchAnalytics();

    };

    function getTag(label,isArray,isYn) {
      var obj = $scope["saved"+label];
      var results = [];

      for(var prop in obj) {
        if(isYn && obj[prop] === "y") return "true";
        else if(isYn) return "false";
        
        if(obj[prop]) results.push(prop);
      }

      if(isArray) return results;
      else if(results.length) return results[0];
      return null;
    }


    $scope.triggerFilterSort = function(){
      if(!$scope.resortSecondaryFilters) return;

      $scope.resortSecondaryFilters = false;
      $scope.secondaryFilters = $filter('menu')($scope.categoryLookup.Service.subs,$scope.lastAppliedTags);

      for(var i = 0, count = $scope.lastAppliedTags.length; i < count; i++){
        var tag = $scope.lastAppliedTags[i];
      }
    };

    $scope.createLocationSpecificLink = function(){
      var data = encodeState();
      ELIService.createLocationSpecificLink(data).then(function(results){
        alert("Location Link Generated: " + results.data.lid );
      });
    };
    $scope.createUserSpecificLink = function(id){
      var data = encodeState();
      ELIService.createUserSpecificLink(data).then(function(results){
        window.prompt("Please copy the link below to share your search results.", results.data.lid);
      });
    };


    $scope.saveState = function() {
       $scope.storeSearchState(encodeState());
    };

    function encodeState(){
      var data = {
        zip: $scope.refineMeta.zip,
        radius: $scope.refineMeta.radius,
        age: simplify($scope.savedAgeGroup),
        diagnosis: simplify($scope.savedDiagnosis),
        filters: simplify($scope.savedFilters),
        searchText: simplify($scope.searchText)
      };
      return data;
    }

    function sendSearchAnalytics(){
        var stype = "Refinement";

        if(!$scope.searchid) {
          $scope.searchid = true;
          stype = "Initial";
        }

        var selections = $scope.results.map(function(element){
          return element.id;
        });

        ELIService.generateSearch({ 
            user_token: $scope.usertoken,
            session_token: $scope.sessiontoken,
            age: getTag("AgeGroup"),
            primary_diagnosis: getTag("Diagnosis"),
            physical_disability: getTag("Disability",false,true),
            type: stype,
            zip: $scope.refineMeta.zip,
            state: 1,
            radius: $scope.refineMeta.radius,
            services: getTag("Filters",true),
            resources: selections
        }).then(function(result){
          $scope.setSearchId(result.data.searchid);
        }); 
    }

    function simplify(data){
      var output = {};
      for(var prop in data){
        if(data[prop]) output[prop] = data[prop];
      }
      return output; 
    }

    function updateSelectedTags(override) {

      if(!override && $scope.filterClasses.mobileEdit) return;

      var models = [$scope.savedAgeGroup, $scope.savedDiagnosis, $scope.savedDisability, $scope.savedFilters];
      var tags = [];
      for(var i = 0, count = models.length; i < count; i++) {
        var model = models[i];
        
        for(var prop in model){

          if(!model[prop]) continue;
          var tag = $scope.tagDictionary[prop];
          if(tag) tags.push(prop.toString());
          else if(model[prop] == "y") tags.push("5");
        }
      }

      $scope.filterClasses.age = false;
      $scope.filterClasses.diagnosis = false;
      $scope.filterClasses.disability = false;
      $scope.filterClasses.filters = false;
      $scope.filterClasses.mobileEdit = false;
      $scope.setMobileEditing(false);
      $scope.profileComplete = true;
      $scope.applyRefinementFilters(tags);
    }

    $scope.edit = function(event,type){
      event.stopImmediatePropagation();
      event.preventDefault();
     // $scope.filterClasses.searchComplete = false;
      $scope.filterClasses[type] = true;
      $scope.nowEditing = type;
    };

    $scope.isSelected = function(primary,secondary){
      var primaryModel = $scope['saved'+primary];
      var secondaryModel = $scope['saved'+secondary];
      var prop;

      if(1) return "editable";

      if($scope.searchid && $scope.nowEditing) {
        if($scope.nowEditing.toLowerCase() === primary.toLowerCase()) return "editable";
        return "uneditable";
      }

      if(!secondary) return "editable";

      for(prop in primaryModel){
        if(primaryModel[prop]) return "editable";
      }
      for(prop in secondaryModel){
        if(secondaryModel[prop]) return "editable";
      }

      return "uneditable";
    };

  	function onReady(value){
  		if(!value) return;

  		$scope.ageGroups = $scope.categoryLookup.Age.subs[0].tags;
  		$scope.diagnosis = $scope.categoryLookup.Diagnosis.subs[0].tags;
  		$scope.primaryFilters = $filter('primary')($scope.categoryLookup.Custom.subs[0].tags);//.concat(
  									//$scope.categoryLookup["Disability Accessible"].subs[0].tags));
  		$scope.secondaryFilters = $scope.categoryLookup.Service.subs;
      $scope.filterClasses.age = true;
      $scope.filterClasses.diagnosis = true;
      $scope.filterClasses.disability = true;
      $scope.filterClasses.filters = true;
      $scope.filterClasses.searchComplete = true;

      $scope.refineMeta.zip = $scope.filters.zip;
      $scope.refineMeta.radius = $scope.filters.radius;

      var order = ['Therapy','Medical & Evaluation Services', 'Education & Employment', 'Adult Programs & Services', 'Parent & Caregiver Support', 'Legal', 'Social & Recreational Activities', 'Other'];

      $scope.secondaryFilters.forEach(function(element){
        element.originIndex = order.indexOf(element.label);//$scope.secondaryFilters.indexOf(element);
      });

      $scope.secondaryFilters.sort(function(a,b){
        if(a.originIndex > b.originIndex) return 1;
        return -1;
      });

      $scope.updateTagDependencies();

      if(__LOADED_SEARCH__) $timeout(function() { loadSearch(__LOADED_SEARCH__); }, 500);
      //emulate();
  	}

    function loadSearch(search){
      __LOADED_SEARCH__ = null;
      $scope.tempAgeGroup = search.age || {};
      $scope.tempDiagnosis = search.diagnosis || {};
      $scope.tempFilters = search.filters || {};
      $scope.refineMeta = {zip: search.zip,radius:search.radius};

      $scope.filterClasses.age = true;
      $scope.filterClasses.diagnosis = true;
      $scope.filterClasses.disability = true;
      $scope.filterClasses.filters = true;
      $scope.filterClasses.searchComplete = true;

      $scope.commit('age','AgeGroup');
      $scope.commit('diagnosis','Diagnosis');
      $scope.commit('filters','Filters');

      $scope.applyRefinementFilters(unpack(search.age,search.diagnosis,search.filters));

      if(search.id) {
        var result = $scope.results.find(function(el) { return el.id === search.id; });// _.findWhere(, {id: search.id});
        $scope.saveState();
        $scope.setCurrentPage($scope.RESULTS_DETAIL_PAGE,false,result);
      }
    }

    function unpack(){
      var output = [];

      for(var i = 0, count = arguments.length; i < count; i++){
        var filters = arguments[i];
         for(var filter in filters){
          if(filters[filter]) output.push(filter.toString());
        }
      }
     
      return output;
    }

    function emulate(){
      $scope.filterClasses.age = false;
      $scope.filterClasses.diagnosis = false;
      $scope.filterClasses.disability = false;
      $scope.filterClasses.filters = false;
      $scope.filterClasses.searchComplete = true;

      $scope.applyRefinementFilters(["10","72","58"]);

    }

    function checkCompletion() {
      var models = [$scope.savedAgeGroup, $scope.savedDiagnosis, $scope.savedDisability, $scope.savedFilters];
      var completions = 0;
      
      for(var i = 0, count = models.length; i < count; i++) {
        var model = models[i];
        for(var prop in model){
          if(!model[prop]) continue;
          completions++;
          break;
        }
      }

      return completions == models.length;
    }


 });